import { useQuery } from "@tanstack/react-query";

import { DeliveryPriorityItem } from "../../deliveryPriority.types";
import { requestDeliveryPriority } from "./getDeliveryPriority.request";

const QUERY_KEY = ["delivery-priority"];

const useGetDeliveryPriority = () => {
  const { data, isLoading, isError, refetch } = useQuery<
    DeliveryPriorityItem[]
  >({
    queryKey: QUERY_KEY,
    queryFn: requestDeliveryPriority
  });

  return {
    items: data ?? [],
    isLoading,
    isError,
    refetch
  };
};

useGetDeliveryPriority.queryKey = QUERY_KEY;

export default useGetDeliveryPriority;
